import type { OneDriveScope, OneDriveScopeBudget } from '@/lib/api/onedrive.js';

/**
 * The cached folder budget with one folder added or replaced. The scopes key caches the whole
 * budget — the list reader selects `scopes` out of it — so an optimistic write has to keep that
 * shape; writing the bare list there broke every reader of `scopes` until the next refetch. With
 * nothing cached there is no limit to keep, so it writes nothing and leaves that to the refetch.
 */
export function withCreatedScope(
  budget: OneDriveScopeBudget | undefined,
  created: OneDriveScope,
): OneDriveScopeBudget | undefined {
  if (!budget) return undefined;
  const exists = budget.scopes.some(
    (entry) => entry.scopeId === created.scopeId,
  );
  return {
    ...budget,
    scopes: exists
      ? budget.scopes.map((entry) =>
          entry.scopeId === created.scopeId ? created : entry,
        )
      : [...budget.scopes, created],
  };
}
